/**
 * SFL homepage rail product image rotate (~4s).
 * Targets [data-sfl-rail-rotate] featured collection grids.
 * Samples product images from collection JSON; respects reduced-motion.
 */
(function () {
  var DEFAULT_MS = 4000;

  function shuffle(a) {
    var arr = a.slice();
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i];
      arr[i] = arr[j];
      arr[j] = t;
    }
    return arr;
  }

  function withWidth(src) {
    if (!src) return src;
    if (src.indexOf('width=') !== -1) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=700';
  }

  function fetchPool(handle, limit) {
    limit = limit || 48;
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit, {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (d) {
        var urls = [];
        (d.products || []).forEach(function (p) {
          var src = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0]));
          if (src) urls.push(withWidth(src));
        });
        return shuffle(urls);
      })
      .catch(function () {
        return [];
      });
  }

  function rotateCard(mediaEl, pool, startIdx, ms) {
    if (!mediaEl || pool.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var img = mediaEl.querySelector('img');
    if (!img) return;
    var i = startIdx % pool.length;
    // Don't replace if user prefers — fade via opacity double-buffer
    var ghost = img.cloneNode(true);
    ghost.classList.add('sfl-rail-img');
    ghost.removeAttribute('srcset');
    ghost.sizes = '100vw';
    mediaEl.style.position = 'relative';
    img.style.transition = 'opacity 0.4s ease';
    ghost.style.cssText =
      'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;opacity:0;transition:opacity 0.4s ease;pointer-events:none;';
    mediaEl.appendChild(ghost);

    setInterval(function () {
      i = (i + 1) % pool.length;
      var next = pool[i];
      ghost.src = next;
      ghost.onload = function () {
        ghost.style.opacity = '1';
        setTimeout(function () {
          img.src = next;
          img.removeAttribute('srcset');
          ghost.style.opacity = '0';
        }, 420);
      };
    }, ms);
  }

  function initSection(section) {
    if (!section || section.dataset.sflRailBound) return;
    var handle = section.getAttribute('data-collection-handle') || section.dataset.collectionHandle;
    if (!handle) return;
    section.dataset.sflRailBound = '1';
    var ms = parseInt(section.getAttribute('data-rotate-ms') || DEFAULT_MS, 10);
    fetchPool(handle, 40).then(function (pool) {
      if (pool.length < 2) return;
      var cards = section.querySelectorAll('.card__media, .card .media');
      cards.forEach(function (media, idx) {
        rotateCard(media, pool, idx * 3, ms + (idx % 3) * 250);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-sfl-rail-rotate]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
